// extracted by mini-css-extract-plugin
module.exports = {"restaurant-layout":"restaurant-layout___gB6xi","add-table-modal":"add-table-modal___iXqZl"};